import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { useImmer } from "use-immer";

import { CAMPAIGN_ROUTES, EXPERIMENT_ROUTES } from "../routes/routes";

export const urlRegex =
  /^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;

export const useIsEditPage = () => {
  const location = useLocation();
  const [isEditPage, setIsEditPage] = useImmer<boolean>(false);

  useEffect(() => {
    setIsEditPage(
      [
        EXPERIMENT_ROUTES.ContentTest_Id,
        EXPERIMENT_ROUTES.PriceTest_Id,
        EXPERIMENT_ROUTES.ShippingTest_Id,
        EXPERIMENT_ROUTES.OfferTest_Id,
        CAMPAIGN_ROUTES.Campaign_Id,
      ].some((route) =>
        matchPath(
          route.endsWith("?") ? route.slice(0, -1) : route,
          location.pathname
        )
      )
    );
  }, [location.pathname]);

  return isEditPage;
};
